import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareDnDIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 6 10' {...props}>
    <path
      fill='currentColor'
      d='M4 10V8h2v2H4zm-4 0V8h2v2H0zm4-4V4h2v2H4zM0 6V4h2v2H0zm4-4V0h2v2H4zM0 2V0h2v2H0z'
    />
  </SvgWrapper>
);

export const DnDIcon = memo(BareDnDIcon);
